import React, { useLayoutEffect, useState } from 'react';
import newArrivals from '/public/images/new-arrivals.jpg';
import waterproof from '/public/images/waterproof.jpg';
import golfClubs from '/public/images/golf-clubs.jpg';
import golfClothing from '/public/images/golf-clothing.jpg';
import golfShoes from '/public/images/golf-shoes.jpg';
import golfBags from '/public/images/golf-bags-trolleys.jpg';
import golfBalls from '/public/images/golf-balls.jpg';
import golfGPS from '/public/images/golf-gps.jpg';
import golfAccessories from '/public/images/golf-accessories.jpg';
import golfGifts from '/public/images/golf-gifts.jpg';
import sale from '/public/images/sale.jpg';
import brands from '/public/images/brands.jpg';
import Typography from 'components/commercetools-ui/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import { DataSource, LinkGroup, SubLink, SubLinkDetail } from 'types/next';
import { agClub } from 'public/locales/en/product.json';
import Link from 'components/commercetools-ui/atoms/link';
import { Level2Item, Level3Item, MenuItem } from 'frontastic/tastics/header/mega-menu';
import { usePathname } from 'next/navigation';

export const getUpdatedNavLinks = () => [
  {
    categoryId: 'new.arrivals',
    name: 'New Arrivals',
    url: `/new`,
    className: '',
    imgURL: newArrivals.src,
    primaryItem: true,
  },
  {
    categoryId: 'golf.clubs',
    name: 'Golf Clubs',
    url: `/golf-clubs`,
    className: '',
    imgURL: golfClubs.src,
    primaryItem: true,
  },
  {
    categoryId: 'golf.clothing',
    name: 'Golf Clothing',
    url: `/golf-clothing`,
    className: '',
    imgURL: golfClothing.src,
    primaryItem: true,
  },
  {
    categoryId: 'golf.shoes',
    name: 'Golf Shoes',
    url: `/golf-shoes`,
    className: '',
    imgURL: golfShoes.src,
    primaryItem: true,
  },
  {
    categoryId: 'golf.bags.trolleys',
    name: 'Golf Bags & Trolleys',
    url: `/golf-bags`,
    className: '',
    imgURL: golfBags.src,
    primaryItem: true,
  },
  {
    categoryId: 'golf.gps',
    name: 'Golf GPS',
    url: `/golf-gps`,
    className: '',
    imgURL: golfGPS.src,
    primaryItem: true,
  },
  {
    categoryId: 'golf.balls',
    name: 'Golf Balls',
    url: `/golf-balls`,
    className: '',
    imgURL: golfBalls.src,
    primaryItem: true,
  },
  {
    categoryId: 'golf.accessories',
    name: 'Golf Accessories',
    url: `/golf-accessories`,
    className: '',
    imgURL: golfAccessories.src,
    primaryItem: true,
  },
  {
    categoryId: 'ag.sale',
    name: 'Sale',
    url: `/sale`,
    className: 'bg-[#e30616]',
    imgURL: sale.src,
    primaryItem: true,
  },
  {
    categoryId: 'ag.brands',
    name: 'Brands',
    url: `/brands`,
    className: '',
    imgURL: brands.src,
    primaryItem: false,
  },
  // {
  //   categoryId: 'golf.gifts',
  //   name: 'Golf Gifts',
  //   url: `/gifts`,
  //   className: '',
  //   imgURL: golfGifts.src,
  // },
  {
    categoryId: 'golf.bags',
    name: 'Golf Bags',
    url: `/golf-bags`,
    className: '',
    imgURL: golfBags.src,
  },
  {
    categoryId: 'golf.bags',
    name: 'Golf Trolleys',
    url: `/golf-trolleys`,
    className: '',
    imgURL: golfBags.src,
  },
  /*
  {
    categoryId: 'ag.waterproof',
    name: 'Waterproof',
    url: `/waterproofs/all-clothing`,
    className: '',
    imgURL: waterproof.src,
  },

  {
    categoryId: 'golf.gifts',
    name: 'Golf Gifts',
    url: `/gifts`,
    className: '',
    imgURL: golfGifts.src,
  },
  */
  {
    categoryId: 'ag.club',
    name: 'AG Club',
    url: `/club-page`,
    className: 'hidden sm:block',
    imgURL: '',
  },
];

export const getLevel2NavLinks = () => [
  {
    categoryId: 'ag.club',
    name: 'AG Club',
    url: `/club-page`,
    className: '',
    imgURL: '',
  },
];
interface HeaderNavigation {
  data: DataSource | undefined;
}

interface MetaData {
  schema: string;
  deliveryId: string;
  name: string;
}

interface Image {
  defaultHost: string;
  endpoint: string;
  name: string;
  id: string;
  _meta: MetaData;
}

export interface LevelTwoLink {
  Heading: string;
  Url: string;
}

export interface LevelTwoCategorySection {
  'Level-Two-Links': LevelTwoLink[];
  name: string;
}

export interface LevelTwoCategory {
  _meta: MetaData;
  'Level-Two-Categories': LevelTwoCategorySection[];
}

export interface LevelOneCategory {
  Heading: string;
  Url: string;
  Image: Image;
  levelTwoCategories: LevelTwoCategory[];
}

// Main type for the JSON structure
type MegaMenuData = LevelOneCategory[];

export type Data = {
  data?: MenuItem;
};

const HeaderNavigationTopLevel = (data: Data) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const updatedNavLinks = getUpdatedNavLinks();
  const [hoveredCategory, setHoveredCategory] = useState<any>(undefined);
  const pathname = usePathname();

  const handleMouseEnter = (name: string | undefined, Url: string | any) => {
    setHoveredCategory({ Name: name, Url: Url });
  };
  const handleMouseLeave = () => {
    setHoveredCategory(undefined);
  };

  const hoveredCategoryData = (data?.data as any)?.find(
    (cat: MenuItem) => cat?.name?.toLowerCase() === hoveredCategory?.Name?.toLowerCase(),
  );

  return !data?.data ? (
    <div className="hidden w-full items-center justify-center bg-black pl-44 transition-all duration-150 xl:flex">
      <ul className="flex w-1240 flex-row items-stretch">
        {updatedNavLinks.map(({ categoryId, url, name, className }) => (
          <li key={categoryId} className={`${className} group relative text-center`}>
            <a
              href={url}
              className="after:ease z-10 flex h-48 cursor-pointer items-center px-15 text-center text-14 uppercase text-white after:absolute after:left-1/2 after:top-0 after:block after:h-2 after:w-0 after:overflow-hidden after:bg-ag_green-500 after:opacity-0 after:[transition:width_0.45s,margin_0.45s,opacity_0.25s,border_0.25s] group-hover:bg-white group-hover:text-black group-hover:after:ml-[-50%] group-hover:after:w-full group-hover:after:opacity-100"
            >
              <Typography className="font-semibold">
                {formatMessage({ id: categoryId, defaultMessage: name })}
              </Typography>
            </a>
          </li>
        ))}
      </ul>
    </div>
  ) : (
    <div
      className={`relative hidden w-full items-center justify-center bg-black pl-23 transition-all duration-150 lg:flex`}
    >
      <ul className="mx-auto flex w-full max-w-7xl flex-row items-stretch">
        {(data?.data as any)?.map((i: MenuItem, index: number) => {
          const isActiveTab = i?.url && pathname?.includes(i?.url?.split('/')?.[1]);
          return (
            <div className="group relative " key={index}>
              <li
                className={`group relative text-center  ${
                  isActiveTab
                    ? 'bg-[#127e57] '
                    : i?.name === 'Sale'
                    ? 'bg-[#fc0000]'
                    : i?.name === 'New Arrivals'
                    ? 'bg-[#127e57]'
                    : ''
                }`}
              >
                <a
                  href={i?.url as any}
                  className={`after:ease after:[transition:width_0.55s,margin_0.55s,opacity_0.35s,border_0.35s]' z-10 flex h-48 cursor-pointer items-center px-15 text-center text-14 uppercase after:absolute after:left-1/2 after:top-0 after:block after:h-2 after:w-0 after:overflow-hidden after:bg-ag_green-500 after:opacity-0
                   ${!isActiveTab && 'after:-translate-x-1/2 after:transition-all after:duration-500'} ${
                    isActiveTab ? 'text-white after:ml-[-50%] after:w-full after:opacity-100' : 'text-white'
                  } group-hover:bg-white group-hover:text-black group-hover:after:w-full group-hover:after:opacity-100`}
                >
                  <Typography className="max-w-[90px] font-bold leading-[14px]">
                    {formatMessage({ id: '/categories', defaultMessage: i?.name })}
                  </Typography>
                </a>
              </li>

              <div className="fixed left-0 z-50 hidden h-[75vh]  w-full  overflow-y-scroll bg-white p-8 pb-30 group-hover:block">
                <div className="ml-20 flex max-w-7xl">
                  {i?.name === 'Brands' && (
                    <div className="ml-30 mt-30 grid w-full grid-cols-5 gap-25">
                      {i?.level2?.map((item: Level2Item, itemIndex: number) => (
                        <a
                          key={itemIndex}
                          href={item?.url ?? '#'}
                          className="list-none  text-left text-sm font-semibold text-black hover:text-[#1CCE8F]"
                        >
                          {item?.name}
                        </a>
                      ))}
                    </div>
                  )}

                  {i?.name === 'AG CLUB' && (
                    <div className="flex flex-wrap justify-center">
                      <div className="flex w-[1100px] items-center justify-center bg-slate-50 py-10">
                        <div className="flex h-[250px] w-[400px] items-center  justify-center rounded-3xl border bg-white shadow-lg shadow-slate-400">
                          <img src={agClub?.image} alt="AG Club Logo" className="mb-4 h-[150px] w-[300px]" />
                        </div>
                        <div className="flex w-[300px] justify-center">
                          <p className="ml-40 text-center text-50 font-semibold text-[#262c5c]">{agClub.text}</p>
                        </div>
                      </div>
                      <a href="/club-page/2019-club-out.html" className="mt-10">
                        <button className="  w-[300px] rounded-md border bg-[#1CCE8F] py-10 font-semibold text-slate-800">
                          FIND OUT MORE
                        </button>
                      </a>
                    </div>
                  )}

                  {i.name !== 'Brands' && i.name !== 'AG CLUB' && (
                    <>
                      <div className="ml-20 flex w-[80%] flex-wrap  ">
                        {i?.level2?.map((item: Level2Item) => (
                          <div key={index} className="w-[20%]">
                            {item.url ? (
                              <a href={item?.url}>
                                <div
                                  key={item?.deliveryId}
                                  className="text-md mb-8 mt-30  text-left font-semibold text-gray-400"
                                >
                                  {item?.name}
                                </div>
                              </a>
                            ) : (
                              <div
                                key={item?.deliveryId}
                                className="text-md mb-8 mt-30  text-left font-semibold text-gray-400"
                              >
                                {item?.name}
                              </div>
                            )}
                            <ul className="space-y-5">
                              {item?.level3?.map((subLink: Level3Item, subIndex: number) => (
                                <li key={subIndex} className="list-none  text-left ">
                                  <a href={`${subLink.url}`} className="text-sm font-semibold text-black">
                                    {subLink?.name}
                                  </a>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </div>
                      <div className="mt-20 items-center justify-center">
                        <img src={i?.image ?? ''} alt="image" className="h-[350px] w-[350px]  object-cover" />
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </ul>
    </div>
  );
};

export default HeaderNavigationTopLevel;
